import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import React from 'react';

import { convertPriorityToBidderTier } from '~/src/dash/api/headerbidders/utils_headerbidder';
import { IFlexibleBiddingThreshold } from '~/src/dash/api/types/flexible_bidding';
import { usePublicaTranslation } from '~/src/dash/publicaUI';

interface IFlexibleBiddingDialogProps {
  onRevert: () => void;
  onConfirm: () => void;
  invalidThresholds: IFlexibleBiddingThreshold[];
  open: boolean;
}
export function FlexibleBiddingDialog({
  open,
  onRevert,
  onConfirm,
  invalidThresholds,
}: IFlexibleBiddingDialogProps) {
  const { t } = usePublicaTranslation();
  return (
    <Dialog open={open} onClose={onRevert} aria-labelledby='form-dialog-title'>
      <DialogTitle id='form-dialog-title'>Cleanup Required</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('BiddersModalFlexibleBiddingError')}</DialogContentText>
        <ul>
          {invalidThresholds.map((threshold) => (
            <li key={threshold.BidderPriority}>
              {t('TierNumber', {
                number: convertPriorityToBidderTier(threshold.BidderPriority.toString()),
              })}
            </li>
          ))}
        </ul>
      </DialogContent>
      <DialogActions>
        {/* Revert Button*/}
        <Button onClick={onRevert} color='secondary'>
          {t('Revert')}
        </Button>
        {/* Confirm Button*/}
        <Button onClick={onConfirm} color='primary' autoFocus>
          {t('Confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
